import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    // hasError tracks if a crash happened
    this.state = { hasError: false, error: null };
  }

  // This updates the state so the next render shows the fallback UI
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  // You can log the error to a service like Sentry here
  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  handleReset = () => {
    // Clear storage because you mentioned clearing storage fixes your app
    localStorage.clear();
    sessionStorage.clear();
    // Reload the page to start fresh
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // THIS IS YOUR FALLBACK UI
      return (
        <div className="d-flex flex-column justify-content-center align-items-center text-center gap-2 vh-100">
          <h1>Oops! Something went wrong.</h1>
          <p>The application crashed due to a data or loading error.</p>
          <button className="btn btn_main p-2" onClick={this.handleReset} >
            Clear Data & Fix App
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}



export default ErrorBoundary;
